import React, {ReactElement, Component, useContext, useEffect} from "react";
import {Col, Row} from "antd";
import {workspace_icon, workspace_icon_dark_blue, workspace_icon_black_gray} from '../../img';
import {left_menu_item, LeftMenuContext, menu_items} from "../../contexts/left-menu";
// import UseMenu from '../workspaces/menus';
import UseMenu from './storage-menu';
import {SideFlyInContext} from '../../contexts/side-menu-fly-in';
import {withRouter} from "react-router-dom";
import {FormattedMessage, injectIntl} from "react-intl";
import {ThemeContext} from "../../contexts/theme";

const StorageInfo: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const set_left_menu_items: React.Dispatch<React.SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
    [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    theme: string = useContext(ThemeContext)[0],
    prevent_click: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
      event.stopPropagation();
    };

  useEffect((): void => {
    set_side_fly_in(true);
  }, [set_side_fly_in]);

  useEffect((): void => {
    set_left_menu_items(menu_items[4]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_left_menu_items]);

  return (
    <Row className="pr-20 mt-20 pl-10">
      <div className={`${side_fly_in ? '' : 'side_fly_in'}`} onClick={prevent_click}>
        <Col sm={2} className="position-fixed left_second_menu">
          <Row className="header no_shadow">
            <Col sm={24} className="box_rounded inside_card_bg">
              <Row>
                <Col sm={24} className="text-center side_menu_img">
                  <img src={theme === 'dark_blue' ? workspace_icon_dark_blue : theme === 'black_gray' ? workspace_icon_black_gray : workspace_icon} alt=""/>
                </Col>
                <Col sm={24} className="card_title text-center">
                  <FormattedMessage id={'persistent_volume'}/>
                </Col>
              </Row>
            </Col>
            <Col sm={24}><UseMenu/></Col>
          </Row>
        </Col>
      </div>
      <Col sm={side_fly_in ? 22 : 24} offset={side_fly_in ? 2 : 0}
           className={side_fly_in ? "side_fly" : 'side_fly_false'}>
        {props.children}
      </Col>
    </Row>
  )
}

export default injectIntl(withRouter(StorageInfo) as any) as any;
